import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getPositionsData } from 'models/positions'; // Importing function to get positions data

/**
 * PositionsView class extends JetView to create a specific view for positions.
 */
export default class PositionsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for text translation
        return {
            type: 'clean', // Clean layout type
            rows: [
                {
                    template: _('Clients by occupation'), // Header template with localized text
                    type: 'header', // Header type
                    css: 'webix_header chart_header', // CSS class for styling
                },
                {
                    view: 'chart', // Chart view
                    type: 'donut', // Donut chart type
                    localId: 'chart', // Local ID for referencing the chart
                    value: '#number#', // Data field for chart values
                    lineColor: (obj) => obj.color, // Function to determine line color based on data
                    color: '#color#', // Data field for chart segment colors
                    innerRadius: 60, // Inner radius for the donut chart
                    padding: { top: 10, bottom: 20, left: 20 }, // Padding around the chart
                    legend: {
                        // Configuration for the chart legend
                        width: 170, // Width of the legend
                        align: 'right', // Alignment of the legend
                        valign: 'middle', // Vertical alignment of the legend
                        marker: {
                            // Marker configuration for legend items
                            type: 'round', // Type of marker
                            width: 7, // Width of marker
                            height: 8, // Height of marker
                        },
                        template: (obj) => _(obj.position), // Template for legend items with localization
                    },
                    shadow: false, // Disable shadow for the chart
                    tooltip: {
                        // Configuration for tooltips
                        template: (obj) => `${_('Clients')}: ${obj.number}`, // Tooltip template with localized text
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and populates the chart with data.
     */
    init() {
        this.$$('chart').parse(getPositionsData()); // Parsing positions data into the chart
    }
}

// FILE DOCUMENTED
